import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1468.18348,451.760056 L1468.18348,1919.94353 L1.13686838e-13,1919.94353 L1.13686838e-13,451.760056 L1468.18348,451.760056 Z M1920,0 L1920,1468.29641 L1581.18843,1468.29641 L1581.18843,338.811571 L451.703587,338.811571 L451.703587,0 L1920,0 Z M338.811571,1016.44601 L1129.3719,1016.44601 L1129.3719,903.508817 L338.811571,903.508817 L338.811571,1016.44601 Z M338.811571,1242.32039 L903.497524,1242.32039 L903.497524,1129.3832 L338.811571,1129.3832 L338.811571,1242.32039 Z M338.811571,1468.30771 L1129.3719,1468.30771 L1129.3719,1355.25758 L338.811571,1355.25758 L338.811571,1468.30771 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCopyCourseSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconCopyCourseSolid, _Component);

  var _super = _createSuper(IconCopyCourseSolid);

  function IconCopyCourseSolid() {
    _classCallCheck(this, IconCopyCourseSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconCopyCourseSolid, [{
    key: "render",
    value: function render() {
      if (process.env.NODE_ENV !== 'production') {}

      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCopyCourse",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCopyCourseSolid.displayName = "IconCopyCourseSolid";
  return IconCopyCourseSolid;
}(Component);

IconCopyCourseSolid.glyphName = 'copy-course';
IconCopyCourseSolid.variant = 'Solid';
IconCopyCourseSolid.deprecated = true;
IconCopyCourseSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCopyCourseSolid;
export { IconCopyCourseSolid };